import adminAuthSlice from "./adminAuthSlice";
import adminWorkingDataSlice from "./adminWorkingDataSlice";
import common from "./common";

const root = {
  adminAuth: adminAuthSlice,
  adminWorkingData: adminWorkingDataSlice,
  common: common,
};

export default root;
